export default __webpack_public_path__ + "static/media/txt_file.cdf5a5ea.png";